import { render, staticRenderFns } from "./index.vue?vue&type=template&id=31e413ca&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=less&"
import style1 from "./index.vue?vue&type=style&index=1&id=31e413ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../kuaishou-frontend-collect/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e413ca",
  null
  
)

export default component.exports